import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  productTypes: null,
  loading: false,
  dummy: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GENERAL_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
